export const SESSION_STORAGE_ID = 'session';
